// extracted by mini-css-extract-plugin
export var skipAnimation = "_37-0";